import { DataLoader } from 'src/app/services/data-loader/data-loader';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import { DataLoaderResult } from '../../../services/data-loader/data-loader-result';
import { standardRun } from '../../../services/data-loader/utils/standard-run';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { FuncService } from '../../../services/functions-api.service';
import { Factory } from 'src/app/utils/Factory';
import {
    ICreatedInstanceId,
    IQueryCacheService,
    IGcpProjectId,
} from 'src/app/utils/IFactory';
import { IDatasourceColumnId } from 'src/app/utils/dashboard-item';
import { QueryCacheService } from 'src/app/services/query-cache.service';

export interface ModifyTimeDataLoaderFactoryOptions
    extends ICreatedInstanceId, IGcpProjectId, IQueryCacheService {
    createdInstanceId: string;
    gcpProjectId: GcpProjectId;
    queryCacheService: QueryCacheService;
    datasetId: string;
    tableId: string;
}

export class ModifyTimeDataLoaderFactory extends Factory<
    DataLoader,
    ModifyTimeDataLoaderFactoryOptions
> {
    override FACTORY_CLASS: string = 'ModifyTimeDataLoaderFactory';

    override getInstance(
        options: ModifyTimeDataLoaderFactoryOptions
    ): DataLoader {
        return new DataLoader(options.createdInstanceId, async function (
            queryContext,
            cancellationToken
        ) {
            const process = async () => {
                const query = `
-- DataLoaderId: ${this.instanceId}
SELECT CONCAT('Last update: ',FORMAT_DATETIME("%Y-%m-%d %H:%M:%S", modify_time)) AS value 
FROM \`${options.gcpProjectId}.visualization.tables_modify_time\` 
WHERE dataset_id = '${options.datasetId}' 
AND table_id = '${options.tableId}'
LIMIT 1`;
                this.emitter.emit(
                    DataLoaderResult.getLoading(this.latestData, queryContext)
                );

                const queryResponse = await DataLoader.runQuery(
                    query,
                    options.queryCacheService
                );
                const data = [...queryResponse.result];

                cancellationToken.throwIfCancellationRequested();

                this.emitter.emit({
                    data: data[0],
                    queryContext,
                    status: 'ok',
                    statusMessage: '',
                    isLoading: false,
                    sqlAndJsProcessing: query,
                });
            };

            await standardRun(this, queryContext, process);
        });
    }
}
